<template>
  <div class="footer-warpper" :class="{ isFixed }">
    <div class="page-width-warpper footer-content">
      <ul>
        <li v-for="(item, i) in navList" :key="i" @click="navSelect(item)">
          {{ item.name }}
        </li>
      </ul>
      <div class="ps">400-086-1018（客服热线：09:00-19:00（7x8小时））</div>
    </div>
    <div class="copyright">
      Copyright © 2008-2022 GONGQIYUN All Rights Reserved .
      <div>
        备案号：
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
          >鲁ICP备2023026017号-1
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      platForm: {},
      navList: [
        { name: "首页", to: "/" },
        { name: "走进华武", to: "/about" },
        { name: "产品中心", to: "/product" },
        { name: "企业动态", to: "/news" },
        { name: "客户服务", to: "/system" },
        { name: "联系我们", to: "/contactUs" },
      ],
    };
  },
  created() {},
  methods: {
    navSelect(item) {
      if (item.break) {
        window.open(`${window.location.origin}${item.to}`, "_blank");
      } else {
        this.$router.push({ path: item.to });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.footer-warpper {
  background: #121212;
  padding: 22px 0;
  &.isFixed {
    position: fixed;
    z-index: 1111;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .footer-content {
    display: flex;
    justify-content: center;
    font-size: 15px;
    color: #ffffff;
    line-height: 1;
    ul {
      display: flex;
      li {
        padding: 0 14px;
        position: relative;
        cursor: pointer;
        &::after {
          content: "";
          width: 1px;
          height: 14px;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -7px;
          background: #3e3e3e;
        }
        &:hover {
          text-decoration: underline;
          color: $main-color;
        }
      }
    }
    .ps {
      margin-left: 14px;
    }
  }
  .copyright {
    margin-top: 36px;
    text-align: center;
    font-size: 12px;
    color: #aeaeae;
    display: flex;
    justify-content: center;
  }
}
.isMobile {
  .footer-warpper {
    padding: 14px 0;
    .footer-content {
      flex-direction: column;
      align-items: center;
      .ps {
        margin-left: 0;
        margin-top: 14px;
      }
      ul {
        li {
          &:last-child {
            &::after {
              display: none;
            }
          }
        }
      }
    }
    .copyright {
      margin-top: 16px;
      font-size: 10px;
      padding: 0 10px;
      display: block;
    }
  }
}
</style>
